import {
  RuleBasedAudienceCombinatorOperator,
  RuleBasedAudienceCondition,
} from "features/mediaDataRoom/models";
import diff from "./assets/diff.svg";
import intersect from "./assets/intersect.svg";
import union from "./assets/union.svg";

export const mapCombinatorOperatorToOption: Record<
  RuleBasedAudienceCombinatorOperator,
  {
    description: string;
    icon: string;
    label: string;
    value: RuleBasedAudienceCombinatorOperator;
  }
> = {
  [RuleBasedAudienceCombinatorOperator.INTERSECT]: {
    description:
      "Keep only users who belong to both, Audience 1 and Audience 2.",
    icon: intersect,
    label: "Keep only overlapping users",
    value: RuleBasedAudienceCombinatorOperator.INTERSECT,
  },
  [RuleBasedAudienceCombinatorOperator.DIFF]: {
    description: "Keep users who are in Audience 1 but not in Audience 2.",
    icon: diff,
    label: "Exclude overlapping users",
    value: RuleBasedAudienceCombinatorOperator.DIFF,
  },
  [RuleBasedAudienceCombinatorOperator.UNION]: {
    description:
      "Keep all users who are either in Audience 1 or Audience 2, or in both.",
    icon: union,
    label: "Keep all users",
    value: RuleBasedAudienceCombinatorOperator.UNION,
  },
};

export const mapAudienceConditionToPresentation: Record<
  RuleBasedAudienceCondition,
  string
> = {
  [RuleBasedAudienceCondition.CONTAINS_ALL_OF]: "Contains all of",
  [RuleBasedAudienceCondition.CONTAINS_ANY_OF]: "Contains any of",
  [RuleBasedAudienceCondition.CONTAINS_NONE_OF]: "Does not contain",
  [RuleBasedAudienceCondition.EMPTY]: "Is empty",
  [RuleBasedAudienceCondition.NOT_EMPTY]: "Is not empty",
};

export const mapCombinatorOperatorToPresentation: Record<
  RuleBasedAudienceCombinatorOperator,
  string
> = {
  [RuleBasedAudienceCombinatorOperator.INTERSECT]:
    "Keep only overlapping users",
  [RuleBasedAudienceCombinatorOperator.DIFF]: "Exclude overlapping users",
  [RuleBasedAudienceCombinatorOperator.UNION]: "Keep all users",
};

export const mapCombinatorOperatorToIcon: Record<
  RuleBasedAudienceCombinatorOperator,
  string
> = {
  [RuleBasedAudienceCombinatorOperator.INTERSECT]: intersect,
  [RuleBasedAudienceCombinatorOperator.DIFF]: diff,
  [RuleBasedAudienceCombinatorOperator.UNION]: union,
};
